import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { YButton } from '../../ui/YButton';
import { YCard } from '../../ui/YCard';
import { PRO_ACCOUNT_PATH, PRO_COPY } from './proCopy';
import './ProPanel.css';

export function ProPanel({ onUpgrade, onDismiss }) {
  const navigate = useNavigate();

  const handleUpgrade = useCallback(() => {
    if (onUpgrade) {
      onUpgrade();
      return;
    }
    navigate(PRO_ACCOUNT_PATH);
  }, [navigate, onUpgrade]);

  const handleDismiss = useCallback(() => {
    if (onDismiss) onDismiss();
  }, [onDismiss]);

  return (
    <YCard className="pro-panel" headerVariant="brand" title={PRO_COPY.kicker} data-testid="pro-panel">
      <h2 className="pro-panel__title">{PRO_COPY.title}</h2>
      <p className="pro-panel__blurb">{PRO_COPY.blurb}</p>
      <div className="pro-panel__actions">
        <YButton type="button" data-testid="pro-panel-upgrade" onClick={handleUpgrade}>
          {PRO_COPY.upgrade}
        </YButton>
        <YButton
          type="button"
          variant="ghost"
          data-testid="pro-panel-dismiss"
          onClick={handleDismiss}
        >
          {PRO_COPY.dismiss}
        </YButton>
      </div>
    </YCard>
  );
}
